define('views/content/distributor_license',['require','backbone','marionette','typeahead','bloodhound','text!templates/content/distributor_license.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('typeahead');
    require('bloodhound');


    var temp = require("text!templates/content/distributor_license.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-license-page',
        titleKey: 'license',
        selectedReseller: null,

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                resellerField: '.resellers-typeahead',
                countField: '#count',
                note: "#note",
                assignButton: '#assign-button'
            };
        },

        events: {
            'click @ui.assignButton': 'assignButtonClicked'
        },
        
        onRender: function() {
            var _this = this;

            // Setup typeahed for customer field
            var resellersTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'resellers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.resellerField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.resellerField.typeahead({
                minLength: 3
            }, {
                name: 'resellers',
                source: resellersTypeahedEngine,
                display: 'company_name'
            });

            // Get selected customer's id
            this.ui.resellerField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedReseller = suggestion.id;
            });
        },

        assignButtonClicked: function () {
            var _this = this;

            if (this.selectedReseller) {
                _this.ui.assignButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'distributor-products/' + this.model.get('id') + '/assign_license/',
                    method: 'post',
                    data: {
                        reseller: this.selectedReseller,
                        count: this.ui.countField.val(),
                        note: this.ui.note.val()
                    },
                    success:function(response) {
                        _this.ui.assignButton.removeClass('loading');

                        _this.model.set(response);
                        _this.render();

                        App.utils.showMessage('success', App.polyglot.t('assign_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.assignButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            }
        }

    });
});
